module.exports = __webpack_public_path__ + "static/media/oret-studio-10.cff2de4d.jpg";